import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ContractRefundPaymentItem.List.IRequest;
type Response = Api.Finance.ContractRefundPaymentItem.List.IResponse;
type Headers = Api.Finance.ContractRefundPaymentItem.List.IHeaders;
const url = '/api/Finance/ContractRefundPaymentItem';
export default async function contractRefundPaymentItemListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
